var common = require('./common')
function tunnel_save_data (json_data) {
  $.ajax({
    url: '/tunnel-adhesion/save/data',
    data: {data:{json_data}},
    method: 'post',
    cache: false,
    dataType: 'json',
    success: function (data) { 
      console.log(data);
      
    },
    error: function (XMLHttpRequest, textStatus, errorThrown)
    {
      if ( errorThrown != 'abort' )
      {
        console.log(XMLHttpRequest);
        console.log(textStatus);
        console.log(errorThrown);
      }
    }
  })
}
jQuery(function($) {
  var removeCDATA = function(str)
  {
    str = str.replace("<!--//-->", "")
    str = str.replace("<![CDATA[// ><!--", "")
    str = str.replace("//--><!]]>", "")
    return str
  }

  var resetControls = function()
  {
    $('#tunnel_adhesion__add_product-input-nid').val('')
    $('.tunnel_adhesion__add_product-cart-controls .cart-controls-qty').val(1)
    $('#tunnel_adhesion__add_product-discount').prop('selectedIndex', 0)
  }

  var nodeClient = function(element, type)
  {
    var lastname = ( element.lastname_account != '' ? element.lastname_account : element.lastname )
    var name     = ( element.name_account != '' ? element.name_account : element.name )
    var the_id   = element.uid

    var output = '<div class="col-sm-6 col-md-6">\
      <div class="client_user__container btn-search-address-client client_user__container-eq-height-item" data-type="' + type + '" data-id="' + element.uid + '">\
        <div class="client_user__content">\
          <div class="client_user__content-left">\
            <div><span class="glyphicon glyphicon-user" aria-hidden="true"></span></div>\
          </div>\
          <div class="client_user__content-right">\
            ' + lastname.toUpperCase() + ' ' + name + ' (#' + the_id + ')\
          </div>\
        </div> <!-- /.client_user__content -->\
      </div> <!-- /.client_user__container -->\
    </div> <!-- /.col -->'
    return output
  }

  var nodeAddress = function(element, taddress)
  {
    var output = '\
    <div class="col-xs-12 col-sm-10 ' + taddress + '-eq-height-item addresspage_block__wrapper" id="address-row-' + element.nid + '">\
      <article>\
        <div class="addresspage_block__container">\
          <label class="addresspage_block__radio" data-country="'+element.country+'">'
          if ( taddress == 'shipping' )
          {
            output += element.nickname + ' #' + element.uid
          }
          else
          {
            output += element.title
          }
    output += '\
            <input type="radio" name="radio-' + taddress + '" class="radio-address" value="' + element.nid + '">\
            <span class="addresspage_block__radio-checkmark"></span>\
          </label>\
          <div class="addresspage_block__content">'

            if ( taddress == 'shipping' )
            {
              var is_adherent = false
              var request = $.ajax({
                url: '/check-if-is-user-member',
                data: {
                  uid: element.uid
                },
                method: 'post',
                cache: false,
                dataType: 'json',
                async: false,
                success: function (data)
                {
                  is_adherent = data.response
                },
                error: function (XMLHttpRequest, textStatus, errorThrown)
                {
                  if ( errorThrown != 'abort' )
                  {
                    console.log(XMLHttpRequest);
                    console.log(textStatus);
                    console.log(errorThrown);
                  }
                }
              })

              var is_adherent_txt = ( is_adherent == true ? Drupal.t('Adhérent') : Drupal.t('Non adhérent') )
              output += '\
              <div class="addresspage_block__user_info-sage">' + element.nickname + ' #' + element.uid + '</div>\
              <div class="addresspage_block__user_info">\
                ' + Drupal.t('Identifiant Drupal') + ' : ' + element.uid + '<br />\
                ' + is_adherent_txt + '\
              </div> <!-- /.addresspage_block__user_info -->'
            }

            if ( element.civility != '' || element.lastname != '' || element.name != '' )
            {
              output += '<strong>' + element.civility + ' ' + element.lastname + ' ' + element.name + '</strong><br />'
            }

            if ( element.address_line1 != '' )
            {
              output += element.address_line1 + '<br />'
            }

            if ( element.address_line2 != '' )
            {
              output += element.address_line2 + '<br />'
            }

            if ( element.cp != '' || element.city != '' )
            {
              if ( element.cp != '' )
              {
                output += element.cp + ', '
              }
              output += element.city + '<br />'
            }

            if ( element.country != '' )
            {
              output += element.country + '<br />'
            }

    output += '\
          </div> <!-- /.addresspage_block__content -->\
          <div class="addresspage_block__content-controls">\
            <a href="#" class="btn-update-address" data-id="' + element.nid + '" data-tunnel="adhesion">' + Drupal.t('Modifier') + '</a>\
          </div><br />\
        </div> <!-- /.addresspage_block__container -->\
      </article>\
    </div> <!-- /.col-xs-12 col-sm-12 -->'

    return output
  }

  var searchClients = function(type)
  {
    var error    = false
    var lastname = ''
    var city     = ''
    var cp       = ''
    var sage_id  = ''
    var type_aux = ''

    if ( type == 'shipping' )
    {
      lastname = $('#client-search-name').val()
      city     = $('#client-search-city').val()
      cp       = $('#client-search-cp').val()
      sage_id  = $('#client-search-idsage').val()
      type_aux = 117
    }
    else if ( type == 'billing' )
    {
      lastname = $('#client-search-name-billing').val()
      city     = $('#client-search-city-billing').val()
      cp       = $('#client-search-cp-billing').val()
      sage_id  = $('#client-search-idsage-billing').val()
      type_aux = 116
    }

    if ( lastname == '' && city == '' && cp == '' && sage_id == '' )
    {
      error = true
    }

    if ( error === false )
    {
      common.globalLoader(true)

      // var url = '/admin/search/client-address?_format=json&type=' + type_aux + '&lastname=' + lastname + '&lastname2=' + lastname + '&city=' + city + '&cp=' + cp + '&sage_id=' + sage_id
      var url = '/admin/search/clients?_format=json&type[]=118&type[]=' + type_aux + '&lastname=' + lastname + '&lastname2=' + lastname + '&city=' + city + '&cp=' + cp + '&sage_id=' + sage_id
      var requestXHr = $.ajax({
        url: url,
        cache: false,
        dataType: 'json',
        success: function (data)
        {
          var html          = ''
          var ids_displayed = []
          if ( data.length > 0 )
          {
              html = '<div class="row">'
              data.forEach(function(element) {
                if ( !ids_displayed.includes(element.uid) ) // This is because can't do a group by with the view
                {
                  html += nodeClient(element, type)
                  ids_displayed.push(element.uid)
                }
              })
              html += '</div> <!-- /.row -->'
          }
          else
          {
            html = '<div class="text-center">' + Drupal.t('Aucun résultat trouvé.') + '</div>'
          }

          $('#client-tunnel-adhesion-' + type + '-container').html(html)
          $('#client-tunnel-adhesion-' + type + '-container .client_user__container-eq-height-item').matchHeight()
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        },
        complete: function(jqXHR, textStatus)
        {
          common.globalLoader(false)
        }
      })
    }
    else
    {
      $.notify({
        message: Drupal.t('Vous devez sélectionner un critère de recherche.')
      },{
        z_index: 2000,
        allow_dismiss: false,
        type: 'danger'
      })
    }
  }

  window.searchAddress = function(uid, type)
  {
    var html  = ''
    var error = false

    if ( uid == '' )
    {
      error = true
    }

    if ( error === false )
    {
      common.globalLoader(true)

      $('#client-tunnel-adhesion-' + type + '-container').html('')

      var url = '/admin/search/address/' + type + '?_format=json&uid=' + uid
      var requestXHr = $.ajax({
        url: url,
        cache: false,
        dataType: 'json',
        success: function (data)
        {
          if ( data.length > 0 )
          {
            html = '<div class="row">'
            data.forEach(function(element) {
              html += nodeAddress(element, type)
            })
            html += '</div> <!-- /.row -->'
          }

          html += controlAddAddress(type, uid)

          $('#client-tunnel-adhesion-' + type + '-container').html(html)
          $('.' + type + '-eq-height-item').matchHeight()
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        },
        complete: function(jqXHR, textStatus)
        {
          common.globalLoader(false)
        }
      })
    }

    return true
  }

  var copySelectedShipping = function ()
  {
    var output      = ''
    var shipping_id = $('input[name="radio-shipping"]:checked').val()

    if ( shipping_id !== undefined && shipping_id != '' )
    {
      output = $('#address-row-' + shipping_id + ' .addresspage_block__content').html()
    }

    return output
  }

  var controlAddAddress = function (type, uid)
  {
    var output = ''
    output += '\
    <div class="col-xs-12 col-sm-10 ' + type + '-eq-height-item addresspage_block__wrapper">\
      <article>\
        <div class="addresspage_block__container btn-add-address__container btn-add-address text-center" data-id="0" data-type="' + type + '" data-uid="' + uid + '" data-tunnel="adhesion">'
    if ( type == 'shipping' )
    {
      output += 'AJOUTER UNE ADRESSE <br> DE LIVRAISON'
    }
    else
    {
      output += 'AJOUTER UNE ADRESSE <br> DE FACTURATION'
    }
    output += '<br>\
          <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>\
        </div> <!-- /.addresspage_block__container -->\
      </article>\
    </div>'
    return output
  }

  // Commons
  $('body').on('change', '.radio-steps[name="tunnel_adhesion-radio"]', function() {
    if ( this.value == 1 )
    {
      $('.tunnel_adhesion__rows').addClass('hidden')
    }
    else
    {
      $('.tunnel_adhesion__rows').removeClass('hidden')
    }
  })
  //

  // Step 0
  $('body').on('click', '.btn-search-client-tunnel-adhesion', function(e) {
    e.preventDefault();
    var type = $(this).data('type')
    searchClients(type)
  })
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  $('body').on('click', '.btn-search-address-client', function(e) {
    var uid    = $(this).data('id');
    var type   = $(this).data('type');
    var result = searchAddress(uid, type);
    if(type == "billing") {
      tunnel_save_data({tiers_id_billing:uid});
    } else {
      tunnel_save_data({tiers_id:uid});
    }
    
  })

  $('body').on('click', '#btn-checkbox-same-shipping', function() {
    var html = ''
    if ( $(this).is(':checked') )
    {
      html = copySelectedShipping()
      $('.div-same-shipping-yes').removeClass('hidden')
      $('.div-same-shipping-no').addClass('hidden')
    }
    else
    {
      $('.div-same-shipping-yes').addClass('hidden')
      $('.div-same-shipping-no').removeClass('hidden')
    }
    $('.div-same-shipping-yes').html(html)
  })

  $('body').change('input[type="radio"][name="radio-shipping"]', function() {
    var html = copySelectedShipping()
    $('.div-same-shipping-yes').html(html)
  });

  $('body').on('click', '.btn-goto-tunnel-adhesion-step-1, .btn-goto-tunnel-adhesion-continue-to-3', function(e) {
    e.preventDefault()

    var error = false
    var href = $(this).attr('href')

    /*
    if ( $('#client-search-numorder').val() == '' )
    {
      error = true
    }
    */

    if ( $('input[name=radio-shipping]:checked').val() == undefined )
    {
      error = true
    }

    if ( $('#btn-checkbox-same-shipping').is(':checked') === false )
    {
      if ( $('input[name=radio-billing]:checked').val() == undefined )
      {
        error = true
      }
    }

    if ( error )
    {
      $.notify({
        message: Drupal.t('Vous devez sélectionner une adresse de livraison et de facturation.')
      },{
        z_index: 2000,
        allow_dismiss: false,
        type: 'danger'
      })
    }
    else
    {
      var billing  = ( $('#btn-checkbox-same-shipping').is(':checked') === true ? $('input[name=radio-shipping]:checked').val() : $('input[name=radio-billing]:checked').val() )
      var shipping = $('input[name=radio-shipping]:checked').val()

      var request = $.ajax({
        url: '/tunnel-adhesion/save/step-3',
        data: {
          billing : billing,
          shipping: shipping,
          checkbox: false,
          form    : null,
          numorder: $('#client-search-numorder').val(),
          mpayment: $('#client-search-modepayment').val(),
          step    : 0
        },
        method: 'post',
        cache: false,
        dataType: 'json',
        success: function (data)
        {
          if ( data.error === true )
          {
            $.notify({
              message: Drupal.t("L'adresses sélectionnée est incorrecte.")
            },{
              z_index: 2000,
              allow_dismiss: false,
              type: 'danger'
            })
          }
          else
          {
            window.location.href = href
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      })
    }
  })
  //

  // Step 1
  $('.adhesion__container').on('click', function(e) {
    e.preventDefault()

    var __this   = $(this)
    var nid      = __this.data('nid')
    var action   = 'add'
    var selected = false

    if ( $(this).hasClass('selected') )
    {
      selected = true
    }

    // Reset
    $('.radio-adhesions[name="adhesion__content-title-radio"]', $('.tunnel_adhesion__rows')).attr('checked', false)
    $('.adhesion__container').removeClass('selected')
    $('.adhesion__container').addClass('unselected')
    //

    if ( selected == false )
    {
      // Mark current
      $('.radio-adhesions[name="adhesion__content-title-radio"]', __this).attr('checked', true)
      __this.removeClass('unselected')
      __this.addClass('selected')
      //
    
      var request = $.ajax({
        url: '/tunnel-adhesion/save/step-1',
        data: {
          nid: nid
        },
        method: 'post',
        cache: false,
        dataType: 'json',
        success: function (data) { 
          console.log(data);
          if(data.error) {
            alert(data.info);
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      })
    }
    else
    {
      $('.adhesion__container').removeClass('unselected')
      var request = $.ajax({
        url: '/tunnel-adhesion/delete/step-1',
        method: 'post',
        cache: false,
        dataType: 'json',
        success: function (data) { },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      })
    }
  })

  $('body').on('click', '.add_documentation_modal-btn-ok', function(e) {
    e.preventDefault();

    var request = $.ajax({
      url: '/dropzone-check-documents',
      data: {},
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        if ( data.response )
        {
          $('#add-documentation-adhesion-modal').modal('hide');
          var modal = $('#add-more-adhesion-modal').data("active");
          if(modal === 1) {
            $('#add-more-adhesion-modal').modal('show');
          } else {
            //var next = $('#container').find('a.add_more_adhesion_modal-btn-close');
            var next = $('body').find('a.add_more_adhesion_modal-btn-close');
            window.location.href= next[0].href;
            //next.click();
          }
          
        }
        else
        {
          $('.section-sub-title:first-child').animate({
            backgroundColor: "#ff0000",
            color: "#fff"
          }, 1000)
          .animate({
            backgroundColor: "#fff",
            color: "#44485a"
          }, 1000);
        }
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    });
  });

  $('body').on('click', '.btn-goto-tunnel-adhesion-step-2', function(e) {
    e.preventDefault()

    var href = $(this).attr('href')
    var nid = $('input[name="adhesion__content-title-radio"]:checked').val()

    if ( $('.tunnel_adhesion__radios_container').length > 0 ) // is admin
    {
      var modal = $('#add-more-adhesion-modal').data("active");
      
      if(modal == 1) {
        $('#add-more-adhesion-modal').modal('show');
      } else {
        //var next = $('#container').find('a.add_more_adhesion_modal-btn-close');
        var next = $('body').find('a.add_more_adhesion_modal-btn-close');
        window.location.href= next[0].href;
        //next.click();
      }
    }
    else
    {
      if ( nid !== undefined )
      {
        var request = $.ajax({
          url: '/check-membership-selected',
          data: {
            nid: nid
          },
          method: 'post',
          cache: false,
          dataType: 'json',
          success: function (data)
          {
            if ( data.required_documentation )
            {
              $('#add-documentation-adhesion-modal').modal('show');
            }
            else
            {
              var modal = $('#add-more-adhesion-modal').data("active");
              
              if(modal == 1) {
                $('#add-more-adhesion-modal').modal('show');
              } else {
                //var next = $('#container').find('a.add_more_adhesion_modal-btn-close');
                var next = $('body').find('a.add_more_adhesion_modal-btn-close');
                window.location.href= next[0].href;
                //next.click();
              }
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown)
          {
            if ( errorThrown != 'abort' )
            {
              console.log(XMLHttpRequest);
              console.log(textStatus);
              console.log(errorThrown);
            }
          }
        });
      }
      else
      {
        $.notify({
          message: Drupal.t('Vous devez sélectionner une adhésion.')
        },{
          z_index: 2000,
          allow_dismiss: false,
          type: 'danger'
        })
      }
    }
  })

  $('body').on('click', '.add_more_adhesion_modal-btn-ok', function(e) {
    e.preventDefault()

    var href    = $(this).attr('href')
    var request = $.ajax({
      url: '/tunnel-adhesion/save/step-15',
      data: {},
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        window.location.href = href
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    })
  })

  $('body').on('click', '.add_more_adhesion_modal-btn-close', function(e) {
    e.preventDefault()
    window.location.href = $(this).attr('href')
  })
  //

  // Step 2
  $('body').on('click', '.btn-goto-tunnel-adhesion-step-3', function(e) {
    e.preventDefault()

    var price_smf   = 0
    var price_cimpa = 0

    var fsmf        = $('input[name="price-donation-free_smf"]').val()
    var fcimpa      = $('input[name="price-donation-free_cimpa"]').val()

    var smf_id      = ''
    var cimpa_id    = ''

    if ( fsmf == '' )
    {
      price_smf = $('input[type=radio][name="price-donation_smf"]:checked').data('amount')
      smf_id    = $('input[type=radio][name="price-donation_smf"]:checked').val()
    }
    else
    {
      price_smf = fsmf
    }

    if ( fcimpa == '' )
    {
      price_cimpa = $('input[type=radio][name="price-donation_cimpa"]:checked').data('amount')
      cimpa_id    = $('input[type=radio][name="price-donation_cimpa"]:checked').val()
    }
    else
    {
      price_cimpa = fcimpa
    }

    var href    = $(this).attr('href')
    var request = $.ajax({
      url: '/tunnel-adhesion/save/step-2',
      data: {
        price_smf  : price_smf,
        price_cimpa: price_cimpa,
        smf_id     : smf_id,
        cimpa_id   : cimpa_id
      },
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        window.location.href = href
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    })
  })

  $('body').on('change', 'input[type=radio][name="price-donation_smf"], input[type=radio][name="price-donation_cimpa"]', function() {
    var value  = $(this).val()
    var amount = $(this).data('amount')
    var dtax   = $(this).data('dtax')
    var bid    = $(this).data('bid')

    if ( value == 'free' )
    {
      $('.price-donation-free_' + bid).removeClass('hide')
      $('.price-donation-free_' + bid).val(amount)
    }
    else
    {
      $('.price-donation-free_' + bid).addClass('hide')
    }

    $('input[name="price-donation-free_' + bid + '"]').val('')

    $('#price-donation-text .n1_' + bid).html(amount.toString().replace('.', ','))
    var t = amount * dtax / 100
    $('#price-donation-text .n2_' + bid).html(t.toString().replace('.', ','))
  })

  $('body').on('change paste keyup', '.price-donation-free-2', function() {
    var amount = $(this).val()
    var dtax   = $(this).data('dtax')
    var bid    = $(this).data('bid')

    $('input[type=radio][name="price-donation_' + bid + '"]').attr('checked', false)
    $('input[type=radio][name="price-donation_' + bid + '"]').prop('checked', false)

    $('#price-donation-text .n1_' + bid).html(amount.toString().replace('.', ','))
    var t = amount * dtax / 100
    $('#price-donation-text .n2_' + bid).html(t.toString().replace('.', ','))
  })
  //

  // Step 3
  $('body').on('click', '.btn-goto-tunnel-adhesion-step-4', function(e) {
    e.preventDefault()
    var error = false
    var href = $(this).attr('href')

    if ( $('input[name=radio-livraison]:checked').val() == undefined )
    {
      error = true
    }
    if ( $('input[name=radio-facturation]:checked').val() == undefined )
    {
      error = true
    }

    if ( $('#checkbox-yearbook').is(':checked') )
    {
      var fields = [
        'form-address-name',
        'form-address-company',
        'form-address-tva',
        // 'form-address-civility',
        'form-address-lastname',
        'form-address-firstname',
        'form-address-address1',
        // 'form-address-address2',
        'form-address-cp',
        'form-address-city',
        'form-address-country',
        'form-address-email',
        // 'form-address-phone',
      ]

      var form  = '#form-address-adhesion-user'
      var type  = $(form + ' select[name="form-address-type"]').val()
      var error = common.validateForm(type, form, fields)
    }

    if ( error )
    {
      $.notify({
        message: Drupal.t('Vous devez sélectionner une adresse de livraison et de facturation.')
      },{
        z_index: 2000,
        allow_dismiss: false,
        type: 'danger'
      })
    }
    else
    {
      var billing  = $('input[name=radio-facturation]:checked').val()
      var shipping = $('input[name=radio-livraison]:checked').val()

      if ( billing == 'facturation' )
      {
        billing = shipping
      }

      var request = $.ajax({
        url: '/tunnel-adhesion/save/step-3',
        data: {
          billing : billing,
          shipping: shipping,
          checkbox: $('#checkbox-yearbook').is(':checked'),
          form    : $('#form-address-adhesion-user').serializeArray(),
          numorder: '',
          mpayment: '',
          step    : 3
        },
        method: 'post',
        cache: false,
        dataType: 'json',
        success: function (data)
        {
          if ( data.error === true )
          {
            $.notify({
              message: Drupal.t("L'adresses sélectionnée est incorrecte.")
            },{
              z_index: 2000,
              allow_dismiss: false,
              type: 'danger'
            })
          }
          else
          {
            window.location.href = href
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      })
    }
  })
  //

  // Step 4
  $('body').on('click', '.btn-goto-tunnel-adhesion-step-5', function(e) {
    e.preventDefault()
    var href  = $(this).attr('href')
    var items = []

    $('.tunnel_adhesion__rows input[type=radio]').each(function () {
      if ( $(this).prop('checked') )
      {
        items.push($(this).val())
      }
    })

    var request = $.ajax({
      url: '/tunnel-adhesion/save/step-4',
      data: {
        items: items
      },
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        window.location.href = href
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    })
  })
  //

  // Step 5
  $('body').on('click', '.subscription__content-text--prices-button input[type="radio"]', function() {
    var name = $(this).attr('name')

    if ( $(this).hasClass('selected') )
    {
      $(this).removeClass('selected')
      $(this).attr('checked', false)
      $(this).prop('checked', false)
    }
    else
    {
      $('input[type="radio"][name="' + name + '"]').removeClass('selected')
      $(this).addClass('selected')
      $(this).attr('checked', true)
      $(this).prop('checked', true)
    }
  })

  $('body').on('click', '.cart-controls-tunnel-adhesion-delete', function(e) {
    e.preventDefault()
    common.globalLoader(true)
    var $this   = $(this)
    var pid     = $this.data('pid')
    var pos     = $this.data('pos')
    var $target = $('#product-' + pid + '-' + $this.data('type'))
    $target.fadeOut('slow', function(){
      var url = '/tunnel-adhesion/remove-item/' + pid + '/' + pos
      var requestXHr = $.ajax({
        url: url,
        cache: false,
        dataType: 'json',
        success: function (data)
        {
          if ( data )
          {
            $('#cartpage-cart-totals').html(data.totals)
            if ( data.count == 0 )
            {
              //window.location.href = data.result
            }
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        },
        complete: function(jqXHR, textStatus)
        {
          common.globalLoader(false)
        }
      })

      $target.remove()
    })
  })

  /*$('body').on('change', '.select-product-discount', function() {
    common.globalLoader(true)

    var dpt = ($(this).val()).split('|')
    var url = '/tunnel-adhesion/apply-discount/' + dpt[0] + '/' + dpt[1] + '/' + dpt[2]
    var requestXHr = $.ajax({
      url: url,
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        if ( data )
        {
          $('#cartpage-cart-totals').html(data.totals)
          $('#cartpage-cart-body').html(data.body)
        }
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      },
      complete: function(jqXHR, textStatus)
      {
        common.globalLoader(false)
      }
    })
  })*/

  $('#tunnel_adhesion__add_product-input').autocomplete({
    source: function (request, response) {
      $.getJSON('/admin/search/publication?_format=json&search=' + request.term, function (data) {
        resetControls()
        response($.map(data, function (value, key) {
            return {
              label    : '#' + value.nid + ' : ' + value.codeachat + ' - ' + value.title,
              value    : value.codeachat,
              nid      : value.nid,
              codeachat: value.codeachat,
              title    : value.title
            };
          })
        );
      });
    },
    select: function( event, ui ) {
      $('#tunnel_adhesion__add_product-input').val(ui.item.codeachat)
      $('#tunnel_adhesion__add_product-input-nid').val(ui.item.nid)
      return false;
    },
    minLength: 2,
    delay: 100
  });

  /*$('body').on('click', '.btn-add-product-tunnel-adhesion', function(e) {
    e.preventDefault()

    var nid = $('#tunnel_adhesion__add_product-input-nid').val()
    if ( nid != '' )
    {
      common.globalLoader(true)
      var uds = $('.tunnel_adhesion__add_product-cart-controls .cart-controls-qty').val()
      var dto = $('#tunnel_adhesion__add_product-discount').val()
      var url = '/tunnel-adhesion/add-product/' + nid + '/' + uds + '/' + dto
      var requestXHr = $.ajax({
        url: url,
        cache: false,
        dataType: 'json',
        success: function (data)
        {
          if ( data )
          {
            $('#cartpage-cart-totals').html(data.totals)
            $('#cartpage-cart-body').html(data.body)
          }

          $('#tunnel_adhesion__add_product-input').val('')
          resetControls()
        },
        error: function (XMLHttpRequest, textStatus, errorThrown)
        {
          if ( errorThrown != 'abort' )
          {
            console.log(XMLHttpRequest);
            console.log(textStatus);
            console.log(errorThrown);
          }
        },
        complete: function(jqXHR, textStatus)
        {
          common.globalLoader(false)
          MathJax.Hub.Queue(["Typeset",MathJax.Hub])
        }
      })
    }
    else
    {
      $.notify({
        message: Drupal.t('Vous devez sélectionner un produit.')
      },{
        z_index: 2000,
        allow_dismiss: false,
        type: 'danger'
      })
    }
  })*/

  $('body').on('click', '.btn-goto-tunnelpublic-adhesion-step-6', function (e) {
    e.preventDefault()
    common.globalLoader(true)

    var checkbox_csv = $('#checkbox-csv').is(':checked')
    var href         = $(this).attr('href')

    var requestXHr   = $.ajax({
      url: '/tunnel-adhesion/save/step-5',
      data: {
        href: href,
        checkbox_csv: checkbox_csv
      },
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        if ( data )
        {
          window.location.href = data.location
        }
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      },
      complete: function(jqXHR, textStatus)
      {
        common.globalLoader(false)
      }
    })
  })

  /*var requestXHrTotals
  $('body').on('change paste keyup', '#amount-emballage, #amount-shipping', function(e) {
    var current_val = $(this).val()

    if ( current_val < 0 || current_val == '' )
    {
      $(this).val(0)
    }

    if (requestXHrTotals && requestXHrTotals.readyState != 4)
    {
      requestXHrTotals.abort()
    }

    requestXHrTotals = $.ajax({
      url: '/tunnel-adhesion/update/totals',
      data: {
        emballage: $('#amount-emballage').val(),
        shipping: $('#amount-shipping').val()
      },
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        $('#cartpage-cart-totals').html(data.totals)
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      },
      complete: function(jqXHR, textStatus)
      {
        common.globalLoader(false)
      }
    })
  })*/

  $('body').on('click', '#reset-emballage, #reset-shipping', function(e) {
    e.preventDefault()
    common.globalLoader(true)

    var el = $(this).find('span')
    el.addClass('glyphicon-refresh-animate')

    var requestXHr = $.ajax({
      url: '/tunnel-adhesion/reset/totals',
      data: {
        type: $(this).data('type')
      },
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        $('#cartpage-cart-totals').html(data.totals)
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
      },
      complete: function(jqXHR, textStatus)
      {
        el.removeClass('glyphicon-refresh-animate')
        common.globalLoader(false)
      }
    })
  })
  //

  // Step 6 (payment)
  $('body').on('click', '.btn-finish-payment-tunnel-adhesion', function (e) {
    e.preventDefault()
    var error = false
    if ( $('input[name=radio-payment]:checked').val() == undefined )
    {
      error = true
    }

    if ( error )
    {
      $.notify({
        message: Drupal.t('Vous devez sélectionner une méthode de paiement.')
      },{
        z_index: 2000,
        allow_dismiss: false,
        type: 'danger'
      })
    }
    else
    {
      common.globalLoader(true)
      common.requestPaymentCheckout($('input[name=radio-payment]:checked').val(), 'membership')
    }
  })
  //
})


// WEBPACK FOOTER //
// ./js/adhesion.js